import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10c4b4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "calendar" }
const _hoisted_2 = { class: "calendar-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "aqi-list" }
const _hoisted_7 = { class: "month-title" }
const _hoisted_8 = { class: "month-aqi" }
const _hoisted_9 = { class: "month-days" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend" }, null, -1))

import moment, { Moment, } from 'moment';
import {
  computed, watch, ref,
} from 'vue';
import { useStore, } from 'vuex';

import { factorColorRender, fontColorRender, } from '@/utils/index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const regionName = ref('');

const regionId = computed<number>(() => store.state.OLMap.regionId) || 320100000000;
const location = computed(() => store.state.OLMap.location.location.city);

const pointGid = computed(() => store.state.airStatus.pointGid);
const pointInfo = computed(() => store.state.airStatus.pointInfo);

const selectCityId = computed(() => store.state.airStatus.selectCityId);
const selectRegionName = computed(() => store.state.airStatus.selectRegionName);

// 接口入参
const params = {
  endDay: moment().format('yyyyMMDD'),
  regionId: String(regionId.value),
  startDay: moment().subtract(5, 'month').format('yyyyMM01'),
  type: 0,
};

// 月份集合
const months = ref<string[]>([]);

for (let i = 0; i < 6; i++) {
  const currentTime = moment(params.startDay).add(i,'month').format('YYYY/MM');

  months.value.push(currentTime);
}

watch(pointGid, (curid) => {
  params.regionId = curid;
  params.type = 1;
  store.dispatch('airStatus/aqi12MonthDatas', params);
});

watch(pointInfo, (curInfo) => {
  if (curInfo.pointName) {
    regionName.value = curInfo.pointName;
  }
});

watch(selectCityId, (curid) => {
  params.regionId = curid;
  params.type = 0;
  store.dispatch('airStatus/aqi12MonthDatas', params);
});

watch(selectRegionName, (curName) => {
  if (curName) {
    regionName.value = curName;
  }
});

watch(regionId, (curRe) => {
  params.regionId = String(curRe);

  // 获取月每日历史aqi数据
  store.dispatch('airStatus/aqi12MonthDatas', params);
});

store.dispatch('airStatus/aqi12MonthDatas',params);

const monthDatas = computed<number>(() => store.state.airStatus.monthDatas);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(regionName.value ? regionName.value : _unref(location)) + "近6个月空气质量日历 ", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (item) => {
            return _createElementVNode("li", {
              class: "month",
              key: item
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(months.value[item-1]), 1),
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthDatas)[months.value[item-1]], (i, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    style: _normalizeStyle({
                backgroundColor: i!=='--' ? _unref(factorColorRender)(Number(i), 'aqi') : '' ,
                color:i!=='--' ? _unref(fontColorRender)(Number(i), 'aqi') : '#000'
              })
                  }, _toDisplayString(i), 5))
                }), 128))
              ])
            ])
          }), 64)),
          _createElementVNode("li", null, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (j) => {
                return _createElementVNode("li", { key: j }, _toDisplayString(j), 1)
              }), 64))
            ])
          ])
        ]),
        _hoisted_10
      ])
    ])
  ]))
}
}

})